import { Component } from 'react';
import { connect } from 'react-redux';

import Icon from 'components/atoms/Icon';
import LoaderSpinner from 'components/atoms/LoaderSpinner';
import Scrollbars from 'react-custom-scrollbars-2';
import { Tooltip } from 'react-tooltip';
import { bindActionCreators } from 'redux';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import {
    DataDisplayType,
    EnviroDisplayType,
    Layout,
    OpenModal,
    PortType,
    RootState,
    SwitchType,
    TransitType,
    UserType,
} from 'types';
import {
    MainControlsInterface,
    MapControlsInterface,
    MenuControlsInterface,
    MetOceanChartControlsInterface,
} from 'types/functions';
import { MetOceanData } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone, getId } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface EnviromentalToolTipStaticProps {
    // unused props but used in getDerivedStateFromProps
    mainControls: MainControlsInterface;
    playbackId: string;
    //unused props
    mapControls: MapControlsInterface;
    currentTime: DateTimeFormat | null;

    port: PortType;
    //unused props
    dateTimeFormat: DateTimeFormat;

    //unused props
    openModelFunction: OpenModal;

    switchs: SwitchType;
    setLayoutAction: SetLayoutAction;
    metOceanChartControls: MetOceanChartControlsInterface;
    menuControls: MenuControlsInterface;
    //unused props
    user: UserType;
    layout: Layout;
}

interface EnviromentalToolTipStaticState {
    transit: TransitType | null;
    currentTime: DateTimeFormat | null;
    //unused state
    dataDisplay: DataDisplayType;
    playbackId: string;
    loading: boolean;
    //unused state
    times: number[];
    //unused state
    timeMenu: boolean;
    // unused state but used in getDerivedStateFromProps
    outlineInterval: number;

    activeTab: string;
    metOceanData: MetOceanData[];
    switchs: SwitchType;
    enviroDisplay: EnviroDisplayType;
}

class EnviromentalToolTipStatic extends Component<EnviromentalToolTipStaticProps, EnviromentalToolTipStaticState> {
    constructor(props: EnviromentalToolTipStaticProps) {
        super(props);
        this.state = {
            enviroDisplay: props.port.meta_data.enviroDisplay,
            switchs: clone(props.switchs),
            dataDisplay: props.port.meta_data.dataDisplay,
            currentTime: props.currentTime,
            transit: null,
            loading: true,
            timeMenu: false,
            playbackId: '',
            outlineInterval: 10,
            times: [10, 30, 60, 180, 300, 600],
            activeTab: 'wind',
            metOceanData: [],
        };
    }

    static getDerivedStateFromProps(props: EnviromentalToolTipStaticProps, state: EnviromentalToolTipStaticState) {
        if (
            props.currentTime?.toTimestamp() != state.currentTime?.toTimestamp() ||
            props.playbackId !== state.playbackId
        ) {
            return {
                currentTime: props.currentTime,
                playbackId: props.playbackId,
                loading: props.playbackId !== state.playbackId,
            };
        }

        if (checkDifferent(props.switchs, state.switchs, true)) {
            return {
                switchs: clone(props.switchs),
            };
        }

        return null;
    }

    componentDidMount(): void {
        this.loadTrackData(true);
    }

    componentDidUpdate(prevProps: EnviromentalToolTipStaticProps, prevState: EnviromentalToolTipStaticState) {
        if (prevState.currentTime?.toTimestamp() != this.state.currentTime?.toTimestamp()) {
            this.loadTrackData(prevState.playbackId !== this.state.playbackId);
        }
    }

    loadTrackData = async (loading: boolean) => {
        this.setState({ loading: loading }, async () => {
            const metOceanData = await this.props.menuControls?.playback?.getMetOceanByTime(this.state.currentTime);

            this.setState({
                loading: false,
                //@ts-ignore
                metOceanData: metOceanData,
            });
        });
    };

    activeTab = (activeTab: string) => {
        this.setState({
            activeTab,
        });
    };

    //unused function
    getValue = (items, group, key) => {
        const item = items.find((item) => item.key === key);

        return item ? { ...item, text: this.formatValue(item, group, key) } : { value: '-', unite: '' };
    };

    formatValue = (instrumentValue, group, key) => {
        if (!group) {
            return instrumentValue.value;
        }
        const display = this.state.enviroDisplay[group][key];

        let value = instrumentValue.value;
        if (value === '-') {
            return value;
        }
        value = value * display.database2display_unit_factor;

        if (!value) {
            return '-';
        }
        return `${value.toFixed(display.decimal)}${display.unit}`;
    };

    //unused function
    reversAngle = (angle) => {
        const difference = angle - 180;

        if (difference < 0) return 360 + difference;

        return difference;
    };

    openMetOceanChart = (type: string) => {
        // TODO
        // this.props.setLayoutAction('DEFAULT',
        //     'metOceanChart',
        //     ['grid', 'chart', 'analysis', 'draw', 'measure', 'menus'],
        //     ['playback', 'PlaybackTransit']
        // );
        //this.props.setLayoutAction('DEFAULT',{ tab: 'metOceanChart' });

        this.props.setLayoutAction([
            {
                action: 'UPDATE_DATA',
                data: {
                    section: 'metOceanChart',
                    data: {
                        backTo: 'replay',
                        vessel: this.state.transit?.vessel.name,
                        key: type,
                    },
                },
            },
            {
                action: 'UPDATE_SECTION',
                data: {
                    name: 'metOceanChart',
                    state: true,
                    display: true,
                    disable: false,
                },
            },
        ]);
        //@ts-ignore
        const { transit } = this.props.mainControls.getTransit(this.props?.layout?.playbackTransit);
        console.log(transit);
        setTimeout(() => {
            this.props.metOceanChartControls.createTransitChart(
                type,
                //@ts-ignore
                transit,
                //@ts-ignore
                this.props.currentTime
            );
        }, 100);
    };

    renderTideData = (values) => {
        return (
            <div className="grid grid-cols-12  w-full justify-end ">
                <div className="text-right col-span-12 font-semibold whitespace-nowrap">
                    {`${this.getValue(values, 'tide', 'height_m').text}`}
                </div>
            </div>
        );
    };

    renderWaveData = (values) => {
        const UUID = getId();
        return (
            <div className="grid grid-cols-12 items-center">
                {this.getValue(values, 'wave', 'mean_direction_from_deg').value !== '-' && this.getValue(values, 'wave', 'mean_direction_from_deg').value !== null && (
                    <div className=" col-span-2 flex gap-1 items-end ">
                        <div className="flex  gap-1 justify-between items-center col-span-2">
                            <div className=" leading-4 relative flex items-center justify-end">
                                {this.getValue(values, 'wave', 'mean_direction_from_deg').value !== '-' && (
                                    <>
                                        <Tooltip
                                            id={UUID}
                                            html={`${translate('mean_direction_from_deg')} ${
                                                this.getValue(values, 'wave', 'mean_direction_from_deg').value
                                            }`}
                                            place={'right'}
                                        />
                                        <svg
                                            className="w-3 h-3 "
                                            viewBox="0 0 24 24"
                                            data-tooltip-id={UUID}
                                            style={{
                                                transform: `rotateZ(${this.reversAngle(
                                                    this.getValue(values, null, 'mean_direction_from_deg').value
                                                )}deg)`,
                                            }}
                                            strokeWidth="2"
                                            stroke="currentColor"
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                            <line x1="12" y1="5" x2="12" y2="19"></line>
                                            <line x1="18" y1="11" x2="12" y2="5"></line>
                                            <line x1="6" y1="11" x2="12" y2="5"></line>
                                        </svg>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className={
                        this.getValue(values, 'wave', 'mean_direction_from_deg') !== '-'
                            ? 'col-span-12 '
                            : 'col-span-10 '
                    }
                >
                    <div className="grid grid-cols-12 items-end w-full">
                        <div className=" col-span-5 text-xxs font-semibold whitespace-nowrap">{translate('sea')}</div>
                        <div className=" col-span-3 text-right font-semibold whitespace-nowrap">
                            {this.getValue(values, 'wave', 'significant_wave_height_sea_m').text}
                        </div>
                        <div className=" col-span-4 text-right font-semibold whitespace-nowrap">
                            {this.getValue(values, 'wave', 'peak_wave_period_sea_s').text}
                        </div>
                    </div>
                    <div className="grid grid-cols-12 items-end ">
                        <div className="col-span-5 text-xxs font-semibold whitespace-nowrap">{translate('swell')}</div>
                        <div className="col-span-3 text-right font-semibold whitespace-nowrap">
                            {this.getValue(values, 'wave', 'significant_wave_height_swell_m').text}
                        </div>
                        <div className="col-span-4 font-semibold text-right whitespace-nowrap">
                            {this.getValue(values, 'wave', 'peak_wave_period_swell_s').text}
                        </div>
                    </div>
                    <div className="grid grid-cols-12 items-end ">
                        <div className="col-span-5 text-xxs font-semibold whitespace-nowrap">{translate('total')}</div>
                        <div className="col-span-3 text-right font-semibold whitespace-nowrap">
                            {this.getValue(values, 'wave', 'significant_wave_height_total_m').text}
                        </div>
                        <div className="col-span-4 text-right font-semibold whitespace-nowrap">
                            {this.getValue(values, 'wave', 'peak_wave_period_total_s').text}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderWindData = (values) => {
        const UUID = getId();
        return (
            <div className="grid grid-cols-12 gap-1">
                <div
                    data-tooltip-weather={`${this.getValue(values, 'wind', 'direction_from_deg').text} 
                    } ${this.getValue(values, 'wind', 'direction_from_deg').text}`}
                    className=" col-span-2 leading-4 relative flex items-center justify-end"
                >
                    {this.getValue(values, 'wind', 'direction_from_deg').text !== '-' && (
                        <>
                            <Tooltip
                                id={UUID}
                                html={`${translate('direction_from_deg')} ${
                                    this.getValue(values, 'wind', 'direction_from_deg').text
                                }`}
                                place={'right'}
                            />
                            <svg
                                className="w-3 h-3 "
                                viewBox="0 0 24 24"
                                data-tooltip-id={UUID}
                                style={{
                                    transform: `rotateZ(${this.reversAngle(
                                        this.getValue(values, null, 'direction_from_deg').value
                                    )}deg)`,
                                }}
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="18" y1="11" x2="12" y2="5"></line>
                                <line x1="6" y1="11" x2="12" y2="5"></line>
                            </svg>
                        </>
                    )}
                </div>

                <div className="col-span-3 font-semibold text-right">
                    {this.getValue(values, 'wind', 'speed_kn').text}
                </div>
                <div className="col-span-7 font-semibold text-right">
                    {` ${translate('gust')} ${this.getValue(values, 'wind', 'gust_kn').text}`}
                </div>
            </div>
        );
    };

    renderCurrentData = (values) => {
        const UUID = getId();
        return (
            <div className="grid grid-cols-12 gap-1">
                <div
                    data-tooltip-weather={`${this.getValue(values, 'watercurrent', 'direction_to_deg').text} 
                    } ${this.getValue(values, 'watercurrent', 'direction_to_deg').text}`}
                    className=" col-span-2 leading-4 relative flex items-center justify-end"
                >
                    {this.getValue(values, 'watercurrent', 'direction_to_deg').text !== '-' && (
                        <>
                            <Tooltip
                                id={UUID}
                                html={`${translate('direction_to_deg')} ${
                                    this.getValue(values, 'watercurrent', 'direction_to_deg').text
                                }`}
                                place={'right'}
                            />
                            <svg
                                className="w-3 h-3 "
                                viewBox="0 0 24 24"
                                data-tooltip-id={UUID}
                                style={{
                                    transform: `rotateZ(${this.getValue(values, null, 'direction_to_deg').value}deg)`,
                                }}
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="18" y1="11" x2="12" y2="5"></line>
                                <line x1="6" y1="11" x2="12" y2="5"></line>
                            </svg>
                        </>
                    )}
                </div>

                <div className=" col-span-10 text-right font-semibold">
                    {this.getValue(values, 'watercurrent', 'speed_kn').text}
                </div>
            </div>
        );
    };

    render() {
        return this.state.switchs.playbackEnviromentalDataOnRightColumn?.value ? (
            <div className="  bg-white no-select   flex flex-col w-staticTooltip   overflow-hidden rounded-md">
                <Scrollbars
                    renderThumbHorizontal={() => <div style={{ display: 'none' }} />}
                    renderTrackHorizontal={() => <div style={{ display: 'none' }} />}
                    style={{
                        height: 'calc( 100vh - 330px)',
                    }}
                >
                    <div className="w-full flex flex-col p-2 ">
                        {this.state.loading ? (
                            <LoaderSpinner className="my-10 mx-20" variant="button"></LoaderSpinner>
                        ) : (
                            <div className=" text-sm border-gray-400 px-2">
                                <div>
                                    {this.state.metOceanData
                                        .filter((info) => {
                                            return (
                                                info.instruments.length && this.props.switchs[`${info.key}Data`].value
                                            );
                                        })
                                        .map((info) => {
                                            return (
                                                <div key={info.key} className="border-b border-gray-400 mb-1">
                                                    <div className="flex justify-between">
                                                        <div className="font-bold text-base my-1 text-primary-link ">
                                                            {translate(info.key)} {translate('data')}
                                                        </div>
                                                        <div
                                                            onClick={() => {
                                                                this.openMetOceanChart(info.key);
                                                            }}
                                                        >
                                                            <Icon className="w-4 h-4 mt-1 cursor-pointer">
                                                                <path d="M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a.9 .9 0 0 0 -1 -.8"></path>
                                                                <path d="M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"></path>
                                                            </Icon>
                                                        </div>
                                                    </div>
                                                    {info.instruments.map((instrument, instrumentIndex) => {
                                                        return (
                                                            <div
                                                                className="flex justify-between items-start mb-1"
                                                                key={instrumentIndex}
                                                            >
                                                                {info.key === 'wind' && (
                                                                    <>
                                                                        <div
                                                                            title={instrument.description}
                                                                            className="truncate w-6/12"
                                                                        >
                                                                            {instrument.description}
                                                                        </div>
                                                                        <div className="w-6/12">
                                                                            {this.state.switchs.windData.value && (
                                                                                <>
                                                                                    {this.renderWindData(
                                                                                        instrument.values
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {info.key === 'tide' && (
                                                                    <>
                                                                        <div
                                                                            title={instrument.description}
                                                                            className="truncate w-7/12"
                                                                        >
                                                                            {instrument.description}
                                                                        </div>
                                                                        <div className="w-5/12">
                                                                            {this.state.switchs.tideData.value && (
                                                                                <>
                                                                                    {this.renderTideData(
                                                                                        instrument.values
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {info.key === 'watercurrent' && (
                                                                    <>
                                                                        <div
                                                                            title={instrument.description}
                                                                            className="truncate w-7/12"
                                                                        >
                                                                            {instrument.description}
                                                                        </div>
                                                                        <div className="w-5/12">
                                                                            {this.state.switchs.watercurrentData
                                                                                .value && (
                                                                                <>
                                                                                    {this.renderCurrentData(
                                                                                        instrument.values
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {info.key === 'wave' && (
                                                                    <>
                                                                        <div
                                                                            title={instrument.description}
                                                                            className="truncate w-1/2"
                                                                        >
                                                                            {instrument.description}
                                                                        </div>
                                                                        <div className="w-1/2">
                                                                            {this.state.switchs.waveData.value && (
                                                                                <>
                                                                                    {this.renderWaveData(
                                                                                        instrument.values
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )}
                    </div>
                </Scrollbars>
            </div>
        ) : null;
    }
}

const enviromentalStaticStateToProps = (state: RootState) => ({
    outlineInterval: state.map.outlineInterval,
    port: state.port.port,
    switchs: state.layout.switchs,
    dateTimeFormat: state.port.dateTimeFormat,
    mainControls: state.layout.mainControls,
    menuControls: state.layout.menuControls,
    playbackId: state.layout.layout.playbackId,
    mapControls: state.map.mapControls,
    openModelFunction: state.layout.openModelFunction,
    user: state.user.user,
    layout: state.layout.layout,
    metOceanChartControls: state.layout.metOceanChartControls,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const enviromentalStaticDispatchToProps = (dispatch: any) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(enviromentalStaticStateToProps, enviromentalStaticDispatchToProps)(EnviromentalToolTipStatic);
